export default __webpack_public_path__ + "static/media/pemetaan-2.c1de7166.jpg";